var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("Topbar", { attrs: { "user-info": _vm.userInfo } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-container" },
        [_c("MainNav"), _vm._v(" "), _c("router-view")],
        1
      ),
      _vm._v(" "),
      _vm.userInfo.id ? _c("ImWeb") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }